import { Component, OnInit } from '@angular/core';
import { AdminService } from '../admin.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Menu } from '../../models/menu.model';


@Component({
  selector: 'app-templates',
  templateUrl: './templates.component.html',
  styleUrls: ['./templates.component.css']
})
export class TemplatesComponent implements OnInit {
  menus: Menu[];
  navigationType = 'link';
  navigationDefault = 'enewsletter';

  constructor(private adminService: AdminService,
              private route: ActivatedRoute,
              private router: Router) { }

  ngOnInit() {
    this.menus = [
      new Menu('Elements', '', [
        new Menu('eMarketing', 'templates/elements/enewsletter'),
        new Menu('Buyer Match', 'templates/elements/buyer-match'),
        new Menu('Quick Enquiry',  'templates/elements/quick-enquiry'),
        new Menu('Brochure',  'templates/elements/brochure'),
        new Menu('Property Guide',  'templates/elements/property-guide'),
        new Menu('Social Media',  'templates/elements/social-media'),
        new Menu('Email Signature',  'templates/elements/email-signature'),
        new Menu('DL Card',  'templates/elements/dl-card'),
        new Menu('Signboard',  'templates/elements/sign-board'),
      ]),
      new Menu('Quick Designs', '', [
        new Menu('eMarketing', 'templates/quick-designs/enewsletter'),
        new Menu('Buyer Match', 'templates/quick-designs/buyer-match'),
        new Menu('Quick Enquiry',  'templates/quick-designs/quick-enquiry'),
        new Menu('Brochure',  'templates/quick-designs/brochure'),
        new Menu('Property Guide',  'templates/quick-designs/property-guide'),
        new Menu('Social Media',  'templates/quick-designs/social-media'),
        new Menu('Email Signature',  'templates/quick-designs/email-signature'),
        new Menu('DL Card',  'templates/quick-designs/dl-card'),
        new Menu('Signboard',  'templates/quick-designs/sign-board'),
      ]),
      new Menu('Masters', '', [
        new Menu('eMarketing', 'templates/masters/enewsletter'),
        new Menu('Buyer Match', 'templates/masters/buyer-match'),
        new Menu('Quick Enquiry',  'templates/masters/quick-enquiry'),
        new Menu('Brochure',  'templates/masters/brochure'),
        new Menu('Property Guide',  'templates/masters/property-guide'),
        new Menu('Social Media',  'templates/masters/social-media'),
        new Menu('Email Signature',  'templates/masters/email-signature'),
        new Menu('DL Card',  'templates/masters/dl-card'),
        new Menu('Signboard',  'templates/masters/sign-board'),
      ])
    ];

    this.adminService.loadMenu(this.menus);

    this.adminService.routeData.next({
      'route': null,
      default: this.navigationDefault,
      type: this.navigationType
    });

  }

}



// WEBPACK FOOTER //
// ./src/app/admin/templates/templates.component.ts